module.exports = __webpack_public_path__ + "./fonts/ab65350043d6ae132db185b643cd308d.eot";